<template>
        <v-card :loading="loading" class="p-5" outlined elevated>
            <v-card-title >Resumes {{(files && files.length) ? files.length : 0}}/{{maxFiles}}</v-card-title>
            <v-card-text>                
                <v-simple-table v-if="files && files.length">
                    <template v-slot:default>
                        <thead>
                            <tr>
                            <th class="text-left">
                                Name
                            </th>
                            <th v-if="selectable">Attach</th>
                            <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                            v-for="f in files"
                            :key="f.name"
                            :style="[(selectedFile == f.id) ? {'background-color':'#fde1fd'} : {}]"
                            >
                                <td>{{ f.original_file_name }}</td>
                                <td v-if="selectable">
                                    <v-icon @click="attachFile(f)" v-if="selectedFile != f.id">mdi-paperclip</v-icon>
                                    <v-icon v-if="selectedFile == f.id">mdi-check</v-icon>
                                </td>
                                <td><v-icon @click="deleteFile(f)">mdi-delete</v-icon></td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-spacer></v-spacer>
                <br/>
                <hr/>
                
                
                <v-form ref="userfilesref" lazy-validation class="bg-white rounded-lg shadow-xl overflow-hidden" v-if="canUpload">
                    <v-text-field v-model="fileform.name" label="Quick name" v-if="0"></v-text-field>
                    <v-textarea v-model="fileform.description" label="Description" v-if="0"></v-textarea>
                    <v-row  align="center" justify="center">
                        <v-col cols="12" sm="12" md="6"  class="text-center">
                            <v-file-input
                                accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain"
                                v-model="fileform.file"
                                label="Add new file"
                                append-icon="mdi-file"
                                clearable
                                
                            ></v-file-input>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-btn @click="upload" class="primary"><v-icon>mdi-upload</v-icon>Upload</v-btn> 
                        </v-col>
                    </v-row> 
                </v-form>   
            </v-card-text>
        </v-card>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    errors: Object,
    state: String,
    baseurl: String,
    selectable: Boolean
  },
  components: {
      
    },
  data() {
    return {
        maxFiles: 3,
        files: [],
        fileform: {
            name: '',
            description: '',
            file: null,
        },
        loading: true,
        canUpload: false,
        selectedFile :null
    }
  },
  computed: {
    
  },
  mounted() {
    console.log('get the file list')
    this.updateFileList();
  },
  watch: {
    
   
    },
  methods: {
    attachFile(f) {
        console.log('attaching',f)
        this.selectedFile = f.id
        this.$emit('selectFile',f)
    },
    deleteFile(f) {
        this.selectedFile = null
        this.$emit('selectFile',null)
        axios.get(this.baseurl+"/user/deleteFile/"+f.id).then((response)=> {
            console.log('delete response',response)
            if (response.status == '200' && response.data)
            {
                this.files = response.data
                if (this.files.length >= this.maxFiles)
                    this.canUpload = false;
                else
                    this.canUpload = true;
                
                
            }
            else
                console.log('delete failed');
        })
    },
    updateFileList() {
        this.loading=true;
        axios.get(this.baseurl+"/user/getFiles").then((response)=> {
            this.files = response.data
            if (this.files.length >= this.maxFiles)
                this.canUpload = false;
            else
                this.canUpload = true;
            
                this.loading=false;
        })
    },
    upload() {
        if (this.files.length < this.maxFiles)
        {
            const formData = new FormData()
            Object.keys(this.fileform).forEach(key => formData.append(key, this.fileform[key]));
            axios.post(this.baseurl+"/user/uploadfile",formData).then((response) => {
            if (response.status == '200' && response.data == true)
            {
                this.updateFileList();
            }
            else
                console.log('upload failed');
            
            });
        }
        
    }
  }
  
}
</script>